import { Locale } from "../locale"

export const homepage = "https://hackle.io"

interface Docs {
  [key: string]: {
    ko: string
    en: string
  }
}

const docs: Docs = {
  hackle_home_video_contents: {
    ko: "https://cdn.hackle.io/video/hackle_platform_introduce_720p.mp4",
    en: "https://cdn.hackle.io/video/hackle_platform_introduce_720p.mp4",
  },
  faq: {
    ko: "https://docs-kr.hackle.io/docs/faq",
    en: "https://docs-en.hackle.io/docs/faq",
  },
  user_guide: {
    ko: "https://docs-kr.hackle.io/docs/getting-started",
    en: "https://docs-en.hackle.io/docs/getting-started",
  },
  abtest_guide: {
    ko: "https://docs-kr.hackle.io/docs/steps-of-an-ab-test",
    en: "https://docs-en.hackle.io/docs/steps-of-an-ab-test",
  },
  sdk_guide: {
    ko: "https://docs-kr.hackle.io/docs/sdk-intro",
    en: "https://docs-en.hackle.io/docs/sdk-intro",
  },
  about_company: {
    ko: "https://www.rocketpunch.com/companies/hackle",
    en: "https://hackle.notion.site/Team-Hackle-464901a680694bf0a3d845b49f8596c4",
  },
  career: {
    ko: "http://careers.hackle.io",
    en: "http://careers.hackle.io",
  },
  blog: {
    ko: "https://blog.hackle.io/",
    en: "https://medium.com/hackle",
  },
  slack: {
    ko: "https://hackle-community.slack.com/join/shared_invite/zt-h6yubvyo-pb0oyy3Dna2D9dvNFZGACQ#/",
    en: "https://join.slack.com/t/hacklecommunity/shared_invite/zt-vo9bm75g-bTtHu3TrER5lYdaPPjIf4A",
  },
  policy_terms_of_service: {
    ko: "https://hackle-tnc.notion.site/f018acbb2fc4459593e9c39b042490fc",
    en: "https://hackle-tnc.notion.site/Terms-of-Service-9b29e3f5de224612a606667d4924bb95",
  },
  policy_privacy: {
    ko: "https://hackle-tnc.notion.site/f0cf2755f00f48029dffbe5d42e7c374",
    en: "https://hackle-tnc.notion.site/Privacy-Policy-5ff91ab441e24845b6840ccc426daeab",
  },
  getting_started_developers_guide: {
    ko: "https://docs-kr.hackle.io/docs/getting-started-developers-guide",
    en:"https://docs-en.hackle.io/docs/getting-started-developers-guide",
  },
  getting_started_product_guide: {
    ko: "https://docs-kr.hackle.io/docs/getting-started-product-guide",
    en: "https://docs-en.hackle.io/docs/getting-started-product-guide",
  },
}

export default function getDocsUrl(code: string): string {
  const { lang } = Locale.getDefault()

  try {
    if (lang === "ko") {
      return docs[code]["ko"]
    }
    return docs[code]["en"]
  } catch {
    if (lang === "ko") {
      return "https://docs-kr.hackle.io"
    }
    return "https://docs-en.hackle.io"
  }
}
